// Core
import React, { useState, useEffect } from "react"
import TransitionLink from "gatsby-plugin-transition-link"
import { isMobile } from "react-device-detect"

// Components
import { setCursorState } from "../cursor/set"
import MobileMenu from "../mobileMenu"

// Styles
import styles from "./internalHeader.module.scss"

// Assets
import Home from "./assets/home.inline.svg"

const InternalHeader = ({ index, leaveEvent, credits }) => {
  const [reveal, setReveal] = useState(false)

  // Animate in
  useEffect(() => {
    let revealTimeout = null

    revealTimeout = setTimeout(
      () => {
        setReveal(true)
      },
      credits ? 0 : 5000
    )

    return () => {
      if (revealTimeout) clearTimeout(revealTimeout)
    }
  }, [])

  return (
    <div className={`${styles.internalHeader} ${reveal ? styles.visible : ""}`}>
      <div className={`container`}>
        {isMobile ? (
          <MobileMenu index={index} leaveEvent={leaveEvent} />
        ) : (
          <TransitionLink
            className={`button ${styles.home}`}
            onMouseEnter={() => setCursorState("pointer", true)}
            onMouseLeave={() => setCursorState("pointer", false)}
            aria-label={"Go to Home Page"}
            to={"/"}
            exit={{
              length: 0,
              zIndex: 5,
            }}
            entry={{
              delay: 0,
              zIndex: 10,
            }}
          >
            <Home />
          </TransitionLink>
        )}
      </div>
    </div>
  )
}

export default InternalHeader
